<template>
  <div class="commonLineup" ref="commonLineup">
    <div class="themeHeader">
      <span
        class="themeItem_title"
        v-text="datas.title ? datas.title : ''"
      ></span>
    </div>
    <div class="themeData">
      <div
        class="echart_dom"
        ref="echartDom_home"
        :style="{ height: `${pHeight}px` }"
      ></div>
    </div>
    <div class="echartText_tip">
      <span>阵型场次</span>
      <span>阵型胜率</span>
    </div>
  </div>
</template>

<script>
// 近期战绩 主题
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'commonLineup',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echartsArr: [],
      pHeight: 0,
    }
  },
  watch: {
    datas(val) {
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    },
  },
  created() {
    // this.pieBgColor = [
    //   'rgba(113, 199, 191, 1)',
    //   'rgba(226, 137, 26, 1)',
    //   'rgba(201, 86, 138, 1)',
    //   'rgba(170, 57, 230, 1)',
    // ]
    console.debug(this.datas)
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      setTimeout(() => {
        this.initChart(this.$refs.echartDom_home, this.isAutoExportPng)
      }, 10)
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myEChart) {
      this.myEChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartsArr = []
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.commonLineup
      console.debug('commonLineup:', echartsBoxDom.clientWidth)
      //横向一个
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = Math.floor((this.pWidth / 1) * 0.65)
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    initChart(echartRef, isAutoExportPng) {
      const name = 'commonLineup'
      let result = this.echartsArr.some((val) => {
        if (val.name === name) {
          return true
        }
      })

      console.debug('result', result)

      if (!result) {
        let Echart = this.$echarts.init(echartRef)
        this.echartsArr.push({
          name: name,
          refs: echartRef,
          echarts: Echart,
        })
        setTimeout(() => {
          Echart.resize()
        }, 0)
      }
      const teamName = this.datas.objectInfo[0].teamName
        ? this.datas.objectInfo[0].teamName
        : ''

      const renderData = this.datas.data.dataList
      // const renderData = [
      //   {
      //     formationUsed: '4141',
      //     useCount: 1,
      //     winPct: '0.0%',
      //   },
      //   {
      //     formationUsed: '352',
      //     useCount: 5,
      //     winPct: '60.0%',
      //   },
      //   {
      //     formationUsed: '424',
      //     useCount: 3,
      //     winPct: '30.0%',
      //   },
      //   {
      //     formationUsed: '4114',
      //     useCount: 2,
      //     winPct: '50.0%',
      //   },
      //   {
      //     formationUsed: '442',
      //     useCount: 4,
      //     winPct: '25.0%',
      //   },
      //   {
      //     formationUsed: '315',
      //     useCount: 2,
      //     winPct: '100.0%',
      //   },
      //   {
      //     formationUsed: '235',
      //     useCount: 2,
      //     winPct: '100.0%',
      //   },
      //   {
      //     formationUsed: '325',
      //     useCount: 2,
      //     winPct: '100.0%',
      //   },
      //   {
      //     formationUsed: '343',
      //     useCount: 5,
      //     winPct: '40.0%',
      //   },
      //   {
      //     formationUsed: '343b',
      //     useCount: 2,
      //     winPct: '50.0%',
      //   },
      // ]
      let legendData = []
      let seriesData = []
      for (let i = 0; i < renderData.length; i++) {
        legendData.push({
          name: `${renderData[i].formationUsed}`,
        })
        seriesData.push({
          name: renderData[i].formationUsed,
          value: renderData[i].useCount,
          tip: `阵型${renderData[i].formationUsed}: 使用${renderData[i].useCount}次 胜率${renderData[i].winPct}`,
        })
      }

      const data = {
        legendData,
        seriesData,
      }
      let options = {
        title: {
          show: false,
          text: '同名数量统计',
          subtext: '纯属虚构',
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b} : {c} ({d}%)',
          formatter(params, ticket, callback) {
            // console.debug(params, ticket, callback)
            return `${teamName}<br/>${params.data.tip}`
          },
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 45,
          bottom: 20,
          data: data.legendData,
          itemWidth: 8,
          itemHeight: 8,
          icon: 'circle',
          pageIconSize: 10,
          formatter: (name) => {
            for (let i = 0; i < renderData.length; i++) {
              if (renderData[i].formationUsed == name) {
                return `${name}: ${renderData[i].winPct}`
              }
            }
            return ''
          },
        },
        series: [
          {
            name: teamName,
            type: 'pie',
            radius: ['20%', '40%'],
            center: ['35%', '50%'],
            data: data.seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
      this.echartsArr.forEach((val, index) => {
        if (val.name === name) {
          console.debug('val.name:', val.name, 'name', name)
          val.echarts.setOption(options)
        }
      })
      //   console.debug('emitEventName:', isAutoExportPng)
      //   if (isAutoExportPng) {
      //     setTimeout(() => {
      //       this.upLoad(echartRef, true, 'uploadData')
      //     }, 500)
      //   }
    },
  },
}
</script>

<style lang="scss" scoped>
.commonLineup {
  position: relative;
  width: 100%;
  height: 22vw;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .themeHeader {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .themeItem_title {
      width: 100%;
      padding: 1.388vw 10% 0 10%;
      font-size: 1.25vw;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      text-align: center;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .themeData {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .echart_dom {
      width: 100%;
    }
  }
  .echartText_tip {
    position: absolute;
    bottom: 0.972vw;
    left: 0;
    z-index: 10;
    width: 100%;
    padding: 0 10% 0 20%;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 0.972vw;
    }
  }
}
.themeItem_main {
  .commonLineup {
    width: 80%;
    .themeHeader {
      display: none;
    }
    .echartText_tip {
      bottom: 2vw;
    }
  }
}
</style>
